import { SUPPORTED_LOCALES, useI18n, type Locale } from "../i18n";

// Native names — a Polish speaker hunting for their language scans for
// "Polski", not "Polish", so these are deliberately not translated.
const NAMES: Record<Locale, string> = {
  en: "English",
  de: "Deutsch",
  nl: "Nederlands",
  sv: "Svenska",
  pt: "Português",
  es: "Español",
  it: "Italiano",
  sr: "Srpski",
  uk: "Українська",
  id: "Bahasa Indonesia",
  hr: "Hrvatski",
  lt: "Lietuvių",
  ro: "Română",
  fr: "Français",
  tl: "Filipino",
  tr: "Türkçe",
  fi: "Suomi",
  bs: "Bosanski",
  no: "Norsk",
  pl: "Polski",
};

export function LanguagePicker() {
  const { locale, setLocale } = useI18n();
  const options = SUPPORTED_LOCALES.map((l) => (
    <option key={l} value={l}>
      {NAMES[l]}
    </option>
  ));
  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => setLocale(e.target.value as Locale);

  return (
    <>
      {/* Phones: the nav row is packed (crest + nation chip + search + account) —
          a full-width name select overflowed it and crushed the nation chip to
          "P..". Show a fixed 36px globe+code chip with an invisible native
          select stretched over it; the platform picker still lists full names. */}
      <span className="relative sm:hidden grid place-items-center w-9 h-8 shrink-0 bg-panel border border-border rounded-lg text-dim font-mono text-[10px] leading-none">
        <span aria-hidden>🌐{locale.toUpperCase()}</span>
        <select
          value={locale}
          onChange={onChange}
          aria-label="Language"
          className="absolute inset-0 opacity-0 cursor-pointer"
        >
          {options}
        </select>
      </span>
      <select
        value={locale}
        onChange={onChange}
        aria-label="Language"
        className="hidden sm:block bg-panel border border-border rounded-lg px-1.5 py-1.5 text-dim font-mono text-xs hover:border-accent transition cursor-pointer max-w-[6.5rem]"
      >
        {options}
      </select>
    </>
  );
}
